import { createFileRoute } from '@tanstack/react-router'
import { ProjectWizard } from '@/components/projects/ProjectWizard'

export const Route = createFileRoute('/_authenticated/projekty/nowy')({
  component: NewProjectPage,
})

function NewProjectPage() {
  return <ProjectWizard />
}
